import React, { useCallback, useEffect, useState } from "react";
import { Modal, notification } from "antd";
import { useTranslation } from "react-i18next";
import Representation from "./Representation";
import { fetchMcpConnections, fetchMcpProStatus, revokeMcpConnection } from "util/mcpApi";
import { MCP_SERVER_URL, copyTextToClipboard } from "util/mcpSetup";

const K = "mcp_connector";

const McpView = ({ onBack }) => {
  const { t } = useTranslation();
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [urlCopied, setUrlCopied] = useState(false);
  const [connections, setConnections] = useState(null);

  const loadConnections = useCallback(async () => {
    const res = await fetchMcpConnections();
    setConnections(res && Array.isArray(res.connections) ? res : { connections: [], organization: false });
  }, []);

  useEffect(() => {
    let active = true;
    fetchMcpProStatus().then((res) => {
      if (!active) return;
      setStatus(res && !res.error && !res.cancel ? res : null);
      setLoading(false);
    });
    loadConnections();
    return () => {
      active = false;
    };
  }, [loadConnections]);

  const handleCopyUrl = async () => {
    const ok = await copyTextToClipboard(MCP_SERVER_URL);
    if (ok) {
      setUrlCopied(true);
      window.setTimeout(() => setUrlCopied(false), 2000);
      notification.success({ message: t(`${K}.copied`) });
    }
  };

  const handleDisconnect = (row) =>
    Modal.confirm({
      title: t(`${K}.disconnect_confirm_title`, { client: row.client_name }),
      content: t(`${K}.disconnect_confirm_body`, { client: row.client_name, email: row.email || "" }),
      okText: t(`${K}.disconnect`),
      okButtonProps: { danger: true },
      cancelText: t(`${K}.consent_deny`),
      onOk: async () => {
        const res = await revokeMcpConnection(row.client_id, row.yours ? null : row.user_id);
        if (res && typeof res.revoked === "number") {
          notification.success({ message: t(`${K}.disconnected`) });
          loadConnections();
        } else if (!res?.cancel) {
          notification.error({ message: t(`${K}.disconnect_failed`) });
        }
      },
    });

  return (
    <Representation
      t={t}
      onBack={onBack}
      loading={loading}
      status={status}
      urlCopied={urlCopied}
      onCopyUrl={handleCopyUrl}
      connections={connections}
      onDisconnect={handleDisconnect}
    />
  );
};

export default McpView;
